// Test IDs for the balance sheet reclassifier
export const LANDING = {
  ctaUpload: "landing-cta-upload",
  langSwitchIT: "landing-lang-it",
  langSwitchEN: "landing-lang-en",
};

export const WIZARD = {
  root: "wizard-root",
  stepIndicator: "wizard-step-indicator",
  // Upload
  fileInput: "wizard-file-input",
  browseBtn: "wizard-browse-btn",
  dropZone: "wizard-drop-zone",
  statementTypeOrd: "wizard-type-ord",
  statementTypeAbb: "wizard-type-abb",
  // Mapping
  mappingTable: "wizard-mapping-table",
  mappingRow: "wizard-mapping-row",
  mappingSelect: "wizard-mapping-select",
  mappingSearch: "wizard-mapping-search",
  confirmBtn: "wizard-confirm-btn",
  backBtn: "wizard-back-btn",
  // Results
  resultsTabs: "wizard-results-tabs",
  exportExcelBtn: "wizard-export-excel-btn",
  exportPdfBtn: "wizard-export-pdf-btn",
  newAnalysisBtn: "wizard-new-analysis-btn",
};
